import { useState, useEffect } from 'react';
import { useDialog } from "react-st-modal";
import MODAL_TABLE from '../modal/modal_Table';

const CLIENT_ID = '301722987834-pec5a9vlojn6redpcneblrgd2ckqdj05.apps.googleusercontent.com';
const API_KEY = 'AIzaSyCLbT_ImiBa4NBDDWrp1pgkFBbTxfBluRM';
const SCOPES = 'https://www.googleapis.com/auth/spreadsheets';

interface ExportProps {
  nametable: string;
  row: Record<string, any>[];
}

export const EXPORT_GS_TS = ({ nametable, row }: ExportProps) => {
  const [tokenClient, setTokenClient] = useState<google.accounts.oauth2.TokenClient | null>(null);
  const [modalT, setModalT] = useState<boolean>(false);
  const dialog = useDialog();
  useEffect(() => {
    const loadScripts = async () => {
      const gapiScript = document.createElement('script');
      gapiScript.src = 'https://apis.google.com/js/api.js';
      gapiScript.onload = () => {
        (window as any).gapi.load('client', initGapiClient);
      };
      document.body.appendChild(gapiScript);

      const gisScript = document.createElement('script');
      gisScript.src = 'https://accounts.google.com/gsi/client';
      gisScript.async = true;
      gisScript.defer = true;
      document.body.appendChild(gisScript);
    };

    const initGapiClient = async () => {
      const gapi = (window as any).gapi;
      const googleAccounts = (window as any).google;

      await gapi.client.init({
        apiKey: API_KEY,
        discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"]
      });

      const client: google.accounts.oauth2.TokenClient = googleAccounts.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: SCOPES,
        callback: (tokenResponse: google.accounts.oauth2.TokenResponse) => {
          if (tokenResponse && tokenResponse.access_token) {
            gapi.client.setToken({
              access_token: tokenResponse.access_token
            });
            handleCreateSheet();
          }
        },
      });

      setTokenClient(client);
    };

    loadScripts();
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (tokenClient) {
        tokenClient.requestAccessToken({ prompt: 'consent' });
      }
    }, 600);
    return () => clearTimeout(timeout);
  }, [tokenClient]);

  const handleCreateSheet = () => {
    setModalT(true);
    const gapi = (window as any).gapi;

    gapi.client.sheets.spreadsheets.create({
      properties: { title: nametable }
    }).then((response: any) => {
      const spreadsheetId = response.result.spreadsheetId;
      const spreadsheetUrl = response.result.spreadsheetUrl;
      renameFirstSheet(spreadsheetId, "Sheet", spreadsheetUrl);
    }).catch((error: any) => {
      alert("No se logró crear la hoja de cálculo. Comuníquese con soporte.");
      console.error('Error al crear la hoja de cálculo:', error);
      setModalT(false);
    });
  };

  const renameFirstSheet = (spreadsheetId: string, newSheetName: string, urlSheet: string) => {
    const gapi = (window as any).gapi;

    gapi.client.sheets.spreadsheets.batchUpdate({
      spreadsheetId,
      requests: [{
        updateSheetProperties: {
          properties: {
            sheetId: 0,
            title: newSheetName
          },
          fields: 'title'
        }
      }]
    }).then(() => {
      updateSheet(spreadsheetId, urlSheet);
    }).catch((error: any) => {
      console.error('Error al renombrar la hoja:', error);
    });
  };

  const transformDataToJsonFormat = (jsonData: Record<string, any>[]): any[][] => {
     if (jsonData.length === 0) {
      return [];
    }
    const getValidValue = (value: any) => {
      if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      ) {
        return value;
      } else if (value === null || value === undefined) {
        return '';
      } else {
        return undefined;
      }
    };
    const headers = Object.keys(jsonData[0]).filter(key => {
    const sampleValue = jsonData[0][key];
    const type = typeof sampleValue;
    return (
        type === 'string' ||
        type === 'number' ||
        type === 'boolean' ||
        sampleValue === null ||
        sampleValue === undefined
      );
    });

    const rows = jsonData.map(item => {
      return headers.map(header => {
        const value = getValidValue(item[header]);
        return value !== undefined ? value : '';
      });
    });
    return [headers, ...rows];
  };

  const updateSheet = (spreadsheetId: string, url: string) => {
    const gapi = (window as any).gapi;
    const values = transformDataToJsonFormat(row);

    gapi.client.sheets.spreadsheets.values.update({
      spreadsheetId,
      range: "Sheet",
      valueInputOption: "USER_ENTERED",
      resource: {
        values
      }
    }).then(() => {
      setModalT(false);
      window.open(url, '_blank');
      dialog.close(true);
    }).catch((error: any) => {
      alert("No se logró actualizar la hoja de cálculo. Comuníquese con soporte.");
      console.error('Error al actualizar la hoja de cálculo:', error);
      setModalT(false);
    });
  };

  return (
    <div>
      <MODAL_TABLE
        open={true}
        message={"Exportando a Google..."}
        message2={""}
        modalGeneral={false}
        modalT={modalT}
      />
    </div>
  );
};
